import React from 'react';
import { AlignmentGuide } from '../utils/snapUtils';

interface AlignmentGuidesProps {
  guides: AlignmentGuide[];
  stagePos: { x: number; y: number };
  stageScale: number;
  canvasWidth: number;
  canvasHeight: number;
}

const AlignmentGuides: React.FC<AlignmentGuidesProps> = ({
  guides,
  stagePos,
  stageScale,
  canvasWidth,
  canvasHeight,
}) => {
  if (guides.length === 0) return null;

  return (
    <>
      {guides.map((guide, index) => {
        const screenPosition = guide.position * stageScale + (guide.type === 'vertical' ? stagePos.x : stagePos.y);
        
        if (guide.type === 'vertical') {
          // 수직 가이드라인
          return (
            <div
              key={`guide-v-${index}`}
              style={{
                position: 'absolute',
                left: screenPosition,
                top: 0,
                width: '1px',
                height: `${canvasHeight}px`,
                backgroundColor: '#3B82F6',
                pointerEvents: 'none',
                zIndex: 1000,
                opacity: 0.7,
              }}
            />
          );
        } else {
          // 수평 가이드라인
          return (
            <div
              key={`guide-h-${index}`}
              style={{
                position: 'absolute',
                left: 0,
                top: screenPosition,
                width: `${canvasWidth}px`,
                height: '1px',
                backgroundColor: '#3B82F6',
                pointerEvents: 'none',
                zIndex: 1000,
                opacity: 0.7,
              }}
            />
          );
        }
      })}
    </>
  );
};

export default AlignmentGuides;

